// extracted by mini-css-extract-plugin
module.exports = {"content":"caseStudyText_content___cGK0","titles":"caseStudyText_titles__HFJck typography_title4__uIGjC","bodies":"caseStudyText_bodies__Irxpr typography_bodyMedium__QIIIF"};